<modal-settings>

    <!-- Modal -->
    <div class="modal fade" id="{state.elid}" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Settings</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">

                    <div class="mb-3">
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" role="switch"
                                   id="allow_unapproved_paid"
                                   checked="{state.allowUnapprovedPaid}"
                                   onchange="{onToggleAllowUnapproved}">
                            <label class="form-check-label" for="allow_unapproved_paid">
                                Allow marking unapproved commissions as paid
                            </label>
                        </div>
                        <div class="form-text">
                            When enabled, any commission can be marked as paid regardless of approval status.
                            When disabled, only approved commissions can be marked as paid.
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <script>

        import PubSub from "pubsub-js";
        import {api_get, api_put} from "../../lib/api";
        import Swal from "sweetalert2";

        export default {
            state: {
                allowUnapprovedPaid: true
            },
            onBeforeMount(props, state) {
                this.state.elid = 'modal-settings' + this.genId();
            },
            getModal(){
                return document.getElementById(this.state.elid);
            },
            onMounted() {
                this.events = [];
                this.modal = new bootstrap.Modal(this.getModal(),{});
                const event1 = PubSub.subscribe('modal.settings.show', this.onShow.bind(this));
                const event2 = PubSub.subscribe('modal.settings.hide', this.onHide.bind(this));

                this.events.push(event1, event2);
            },
            onUnmounted() {
                this.events.forEach(e => PubSub.unsubscribe(e));
                this.modal.dispose();
            },
            onShow(){
                this.loadSettings();
                this.modal.show();
            },
            onHide(){
                this.modal.hide();
            },
            loadSettings(){
                api_get('settings/allow_unapproved_paid').then((res)=>{
                    if(res.status == 200 && res.data && res.data.value !== undefined){
                        const value = res.data.value === 'true';
                        this.update({
                            allowUnapprovedPaid: value
                        });
                        this.$('#allow_unapproved_paid').checked = value;
                    }
                }).catch((err)=>{
                    // Setting doesn't exist yet, default to true
                    this.update({
                        allowUnapprovedPaid: true
                    });
                    this.$('#allow_unapproved_paid').checked = true;
                });
            },
            onToggleAllowUnapproved(e){
                const value = e.target.checked;

                api_put('settings/allow_unapproved_paid', { value: value.toString() }).then((res)=>{
                    if(res.status == 200){
                        this.update({
                            allowUnapprovedPaid: value
                        });
                        PubSub.publish('settings.updated', { key: 'allow_unapproved_paid', value: value });
                        Swal.fire({
                            icon: 'success',
                            title: 'Setting Updated',
                            text: 'The setting has been saved.',
                            timer: 1500,
                            showConfirmButton: false
                        });
                    }
                }).catch((err)=>{
                    console.error('Error updating setting:', err);
                    // Revert the checkbox
                    e.target.checked = !value;
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Could not update the setting.',
                    });
                });
            }
        }
    </script>

</modal-settings>
